import React from 'react';
import { View, Text, TextInput, ScrollView, Alert } from 'react-native';
import { connect } from 'react-redux';

import Colors from "../../constants/Colors";
import RatingComponent from "../../components/rating/RatingComponent";
import {ButtonWithSpinner, Card, ConfirmationDialogue, InformationDialogue, Spacing} from "../../components";
import post from "../../api/methods/post";
import {JOURNEY_FEEDBACK} from "./api/journeyEndpoints";
import NavBar from "../../components/NavBar";

class JourneyRatingScreen extends React.Component {

    state = {
        isSending: false,

        knowledgeRating: 0,
        contentClarityRating: 0,
        generalComment: "",

        showConfirmationModal: false,
        showSuccessModal: false,
        showErrorModal: false,
    }

    handleSend = async () => {
        if (this.state.isSending) return;
        this.setState({ isSending: true });

        try {

            const payload = {
                journeyId: this.props.journeyId,
                userId: this.props.userId,
                knowledgeRating: this.state.knowledgeRating,
                contentClarityRating: this.state.contentClarityRating,
                generalComment: this.state.generalComment
            }

            let result = await post(JOURNEY_FEEDBACK, payload);

            this.setState({ showSuccessModal: true });

        } catch (e) {
            console.log(e);
            this.setState({ showSuccessModal: false });
        }

        this.setState({ isSending: false });
    }

    render() {
        return (
            <NavBar title={"Enviar Feedback"}>

                <ConfirmationDialogue
                    isModalVisible={this.state.showConfirmationModal}
                    onClose={() => this.setState({ showConfirmationModal: false })}
                    onConfirm={() => {
                        this.handleSend();
                        this.setState({ showConfirmationModal: false });
                    }}
                    titleText={"Confirmar"}
                    descriptionText={"Você confirma que quer enviar este feedback?"}
                />

                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro"}
                    descriptionText={"Aconteceu um erro ao enviar o seu feedback! Tente novamente mais tarde."}
                    onClose={() => this.setState({ showErrorModal: false })}
                />

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso"}
                    descriptionText={"Seu feedback foi enviado com sucesso!"}
                    onClose={() => this.props.history.goBack()}
                />

                <View style={{ width: 600 }}>
                    <Text style={{ color: Colors.fontColorOnBackground, fontSize: 16, textAlign: 'center' }}>
                        O seu feedback é muito importante para continuarmos a melhorar a plataforma e os conteúdos que estamos oferecendo!
                    </Text>

                    <RatingComponent
                        handleOnPress={(newValue) => this.setState({ knowledgeRating: newValue })}
                        title={"Apredizagem"}
                    />

                    <RatingComponent
                        handleOnPress={(newValue) => this.setState({ contentClarityRating: newValue })}
                        title={"Clareza do conteúdo"}
                    />

                    <Text style={{ fontSize: 22, color: Colors.fontColorOnBackground }}>
                        Comentário:
                    </Text>
                    <TextInput
                        style={{ backgroundColor: 'white', color: 'black', minHeight: 140, maxHeight: 140, padding: 8, borderRadius: 8, textAlignVertical: 'top'}}
                        value={this.state.generalComment}
                        placeholder={"Qualquer comentário que você queira enviar!"}
                        placeholderTextColor={'gray'}
                        onChangeText={(newValue) => this.setState({ generalComment: newValue })}
                        multiline
                    />


                    <Spacing height={12} />
                    <ButtonWithSpinner
                        isLoading={this.state.isSending}
                        text={"Enviar"}
                        onPress={() => this.setState({ showConfirmationModal: true })}
                        containerPropsStyle={{ height: 40, borderRadius: 8 }}
                        textPropsStyle={{ fontSize: 18 }}
                    />
                </View>
            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        journeyId: state.journey.currentJourney === null ? null : state.journey.currentJourney.id,
    }
}

export default connect(mapStateToProps)(JourneyRatingScreen);
